module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "advice-table-container"
  }, [_vm._t("reasontype", [_c('span', {
    staticClass: "floatr advice-tip"
  }, [_vm._v("采纳以下"), _c('i', {
    staticClass: "red"
  }, [_vm._v(" " + _vm._s(_vm.adviceSuggestNum))]), _vm._v(" 个建议预计展现量提升"), _c('i', {
    staticClass: "red"
  }, [_vm._v(" " + _vm._s(_vm.adviceEstiAddAdpv))]), _vm._v("，点击量提升"), _c('i', {
    staticClass: "red"
  }, [_vm._v(" " + _vm._s(_vm.adviceEstiAddAdclick))])])]), _c('div', {
    staticClass: "advice-table"
  }, [_c('HeadFixedTable', {
    attrs: {
      "classname": "opt-table visible-table-td",
      "columns": _vm.currentColumns,
      "checkbox": _vm.hasCheckbox,
      "check_all": _vm.hasCheckbox,
      "checkbox_length": 1000,
      "isAllChecked": _vm.isAllChecked,
      "hasPagination": true,
      "list": _vm.currentList
    },
    on: {
      "pageChange": _vm.pageChange
    },
    scopedSlots: {
      "submit_planTime-td": function(props) {
        return [_c('span', [_vm._v(_vm._s(_vm._f("suggestTime")(props.item.submit_planTime)) + " ")]), _c('span', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (_vm.isEditable && !props.item.status),
            expression: "isEditable && !props.item.status"
          }],
          staticClass: "btn btn-icon",
          on: {
            "click": function($event) {
              $event.stopPropagation();
              _vm.openTimePicker(props.item)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-edit"
        })]), _c('span', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (props.item.suggestTimeEdit),
            expression: "props.item.suggestTimeEdit"
          }],
          staticClass: "service-timepicker",
          on: {
            "click": function($event) {
              $event.stopPropagation();
              _vm.stop($event)
            }
          }
        }, [_c('div', {
          staticClass: "timepicker-panel"
        }, [_c('i', {
          staticClass: "triangle"
        }), _c('Timepicker', {
          attrs: {
            "timearrstring": _vm.reformTimeString(props.item.submit_planTime)
          },
          on: {
            "confirm": _vm.updatePlanTime,
            "cancel": function($event) {
              _vm.closeTimePicker(props.item)
            }
          }
        })], 1)])]
      },
      "delete-td": function(props) {
        return [_vm._t("delete", null, {
          item: props.item
        })]
      },
      "status-td": function(props) {
        return [_vm._t("status", null, {
          item: props.item
        })]
      }
    }
  })], 1)], 2)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-37c6ee6b", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-37c6ee6b!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pageview/web/service_advice_table.vue
// module id = 738
// module chunks = 0